// extracted by mini-css-extract-plugin
export default {"slider-video":"SliderTrackVideo_slider-video__GS+6v"};